module.exports = __webpack_public_path__ + "img/portf1.0b5db327.png";